import { IdentityApi, PropertyImagesApi, RestApiConfig } from "@10x/dubai-rest-api";
import { TabuMobileConfig } from "@10x/tabu-mobile-api";
import rest from "@eres/rest";
import { getGuestToken, getToken as getUserToken, getUser, setGuestToken, setSSOUser, setToken } from "@my-dld/utils/User";
import { RequestHeaders } from "@eres/rest/dist/Processor";
import { I8N, StringUtil } from "@eres/core";
import { isSSOEndpoint, profile } from "@eres/ssoapi/api";
import { SSOApi, SSOConfig } from "@eres/ssoapi";
import { EjariApiConfig } from "@eres/ejari-api";
import { RTRegistrationConfig } from "@eres/rtregistrationapi";
import { GreenListConfig } from "../../greenlistapi";
import { clearLocalData, logout } from "@10x/sso";
import Actions from "@my-dld/actions";
import { OwnerCommitteeConfig } from "../../ownercommitteeapi";
import { VIPOwnerConfig } from "../../vipownerapi";
import { RVSApi, RVSConfig } from "../../rvsapi";
import { enocMApi, enocMConfig } from "../../enocapi";
import { MollakServiceChargeConfig } from "@eres/mollakservicechargeapi";
import { ExpernalValuationConfig } from "../../valuationapi";
import { MortgageQuotationConfig } from "../../mortgagequotationapi";
import { VaultAPI, VaultConfig } from "@eres/dldvault/api";
import { RDCCasesConfig } from "../../rdcapi";
import { getAppServices } from "@10x/coreapp";
import AddPropertyConfig from "@10x/addproperty/api/config";
import { privateSellConfig } from "../../apis/privatesell";
import { BcsConfig } from "../../bcsConfig";
import { AskMalikApi, AskMalikConfig } from "@10x/askmalik-api";
import HandTakeOverAPIConfig from "@10x/handtakeover/api/config";
import { isUploadUrl } from "@10x/handtakeover/api/api";
import { Base64 } from "js-base64";
import { guestAuthenticate } from "@10x/dubai-rest-api/dist/identity/api";
import jopConfig from "../JOPServices/Api/config";
import MollakMeydaanConfig from "./Portfolio/MollakMeydaanAPI/config";


export function isGuestAuthInfo( data: any ) {
	const methodIdentity = data?.MethodIdentity ?? data?.methodIdentity;
	const method = data.Method ?? data?.method;
	return methodIdentity === "guest" && method === "ANONYMOUS";
}

function updateToken( url: string, token: string, request?: RequestData ) {

	/*if (url && url.startsWith(appConfig.mashrooiAPI().endPoint()))
		User.setMashooiToken(token);
	else if (url && (url.startsWith(appConfig.rdcAPI().endPoint())))
		User.setRDCToken(token);
	else if (url && (url.startsWith(appConfig.rdcMobileAPI().endPoint()))) {
	} else if (url && (url.startsWith(appConfig.rdcQueueTicketAPI().endPoint()))) {
	} else if (url && (url.startsWith(appConfig.dldCoreServiceAPI().endPoint()))) {
	} else if (url && (url.startsWith(appConfig.classificationRankAPI().endPoint()))) {
	} else if (url && url.startsWith(appConfig.caseInquiryAPI().endPoint()))
		User.setRDCCaseVerifyToken(token);
	else if (url && url.startsWith(appConfig.taqyimeeAPI().endPoint()))
		User.setTaqyimeeToken(token);
	else if (url && url.startsWith(appConfig.simsariAPI().endPoint()))
		User.setSimsariToken(token);
	else*/
	if ( url && url.startsWith( OwnerCommitteeConfig.default.ownerCommitteeAPI().endPoint() ) )
		return;

	if ( url && url.startsWith( RVSConfig.default.rvsAPI().endPoint() ) ) {
		return;
	}
	if ( url && url.startsWith( IdentityApi.authUri() ) ) {
		try {
			let hs = request?.init?.headers;
			if ( hs ) {
				const headers = new Headers( hs );
				const authHeader = headers?.get?.( "authorization" );
				if ( authHeader ) {
					const authInfo = authHeader.split( " " );
					if ( authInfo.length > 1 ) {
						const a = authInfo[ 1 ];
						const data = JSON.parse( Base64.decode( a ) );
						if ( isGuestAuthInfo( data ) ) {
							setGuestToken( token );
							return;
						}
					}
				}
			}

		} catch ( e ) {

		}

	}
	setToken( token );
}

export function retryApi( url: string, input: RequestInfo, init?: RequestInit ): Promise<Response> {
	return fetch( input, init ).then( response => {
		const method = init?.method ?? "get";
		return handleHttpResponse( method, url, response, );
	} );
}

export function retryRequest( url: string, input: RequestInfo, init?: RequestInit ): Promise<Response> {
	const options = init ?? {};
	const h = new Headers( init?.headers );
	options.isRetry = true;
	const nh: { [ k: string ]: string } = {};
	if ( h && typeof h.delete === "function" ) {
		h.delete( "token" );
	}
	if ( h && typeof h.forEach === "function" ) {
		h.forEach( ( v, k ) => {
			nh[ k ] = v;
		} );
	}
	let token = getToken( url );
	if ( token ) nh[ "TOKEN" ] = token;
	options.headers = new Headers( init?.headers );
	return retryApi( url, input, options );
}

export function handleRateLimit( url: string, input: RequestInfo, init?: RequestInit ) {
	return new Promise<any>( ( resolve, reject ) => {
		let wait = 1000 + Math.trunc( ( Math.random() * 1000 ) );
		setTimeout( () => {
			retryRequest( url, input, init ).then( resolve ).catch( reject );
		}, wait );
	} );
}

function handleHttpResponse( httpMethod: string, url: string, response: Response ): Promise<Response> {
	let exc: any = {};
	if ( isSSOEndpoint( url ) ) {
		// let cookie = response.headers.get("Set-Cookie")
	}
	if ( response.status === 200 ) {
		let userT = response.headers.get( "token" );
		if ( userT ) {
			updateToken( url, userT, response.request );
		}
	} else {
		let errorMessage = "Webservice Error \n";
		if ( response && response.status === 500 ) {
			// handle server error
		}
		if ( response && response.status === 401 ) {
			// handle unauthorized
			if ( !isSSOEndpoint( url ) && !VaultAPI.isVaultEndpoint( url ) ) {
				if ( getUser() != null ) {
					clearLocalData();
					getAppServices().storeService.getStore().dispatch( {
						type: Actions.USER_LOGGED_OUT,
					} );
					logout().then().catch();
					errorMessage = "Session Expired \n";
				} else {
					// update guest token and retry
					const req = response?.request;
					const options = req?.init ?? {};
					const method = options?.method ?? "get";
					if ( method?.toLowerCase() === "get" && url.includes( "dubailand.gov.ae" ) && options.isRetry !== true ) {
						return guestAuthenticate().then( () => {
							return retryRequest( url, req?.input!, req?.init );
						} ).catch( e => {
							exc = {};
							let msg = "Webservice Error \n";
							msg += response.status;
							if ( response.statusText ) {
								msg += " " + response.statusText;
							}
							exc.type = "webservice_error";
							exc.message = msg;
							exc.code = response.status;
							exc.source = response;
							exc.toString = () => {
								return exc.message;
							};
							throw exc;
						} );
					}
				}
			}
		} else if ( response && response.status === 429 ) {
			// retry rate limited apis
			const req = response?.request;
			return handleRateLimit( url, req?.input!, req?.init );
		}
		exc = {};
		errorMessage += response.status;
		if ( response.statusText ) {
			errorMessage += " " + response.statusText;
		}
		exc.type = "webservice_error";
		exc.message = errorMessage;
		exc.code = response.status;
		exc.source = response;
		exc.toString = () => {
			return exc.message;
		};
		throw exc;
	}
	return Promise.resolve( response );
}

export function getToken( url: string ): string | null | undefined {
	let t = getUserToken();
	if ( url && ( url.startsWith( OwnerCommitteeConfig.default.ownerCommitteeAPI().endPoint() ) ) ) {
		// url.startsWith( jopConfig.jopAPI().endPoint() )
		return null;
	}
	if ( url && url.startsWith( ExpernalValuationConfig.default.classificationRankAPI().endPoint() ) ) {
		t = ExpernalValuationConfig.default.classificationRankAPI().token();
	}
	if ( StringUtil.isEmptyStringOrNull( t ) ) {
		return getGuestToken();
	}
	return t;
}

function TokenHeaderProcessor( httpMethod: string, url: string, headers: RequestHeaders, extraHeaders?: RequestHeaders ) {
	if ( extraHeaders && extraHeaders.hasOwnProperty( "Token" ) ) {
		if ( extraHeaders.Token == null ) delete extraHeaders.Token;
		return headers;
	}
	let t = getToken( url );

	if ( t && !StringUtil.isEmptyStringOrNull( t ) ) {
		return {
			...headers,
			"TOKEN": t,
		};
	}
	return headers;

}

function noContentType( httpMethod: string, url: string, headers: RequestHeaders ) {
	if ( url && ( url.startsWith( OwnerCommitteeConfig.default.ownerCommitteeAPI().endPoint() + "owner/register/file/" ) ||
		url.startsWith( jopConfig.jopAPI().endPoint() + "jopService/file" ) ) )
		return true;
	else if ( RVSApi.isRVSUploadUrl( url ) ) {
		return true;
	} else if ( enocMApi.isEnocMUploadUrl( url ) ) {
		return true;
	} else if ( profile.getProfilePicUri() === url ) {
		return true;
	} else if ( AskMalikApi.getPostQuestionUrl() === url ) {
		return true;
	} else if ( url.match( PropertyImagesApi.getUploadImageUrl() ) !== null ) {
		return true;
	} else if ( isUploadUrl( url ) ) {
		return true;
	}
	return false;
}

function DefaultHeaderProcessor( httpMethod: string, url: string, headers: RequestHeaders ) {
	const defaultHeaders: any = { "Accept": "application/json", };
	const hasContent = httpMethod === "POST" || httpMethod === "PUT";
	if ( hasContent && !noContentType( httpMethod, url, headers ) ) {
		defaultHeaders[ "Content-Type" ] = "application/json";
	}
	if ( url.startsWith( RestApiConfig.default.propertySvcApi().endPoint() ) ) {
		defaultHeaders[ "Accept-Language" ] = I8N.locale();
		defaultHeaders[ "Language" ] = I8N.locale();
	}
	if ( url.startsWith( AskMalikConfig.default.askMalikAPI().endPoint() ) ) {
		defaultHeaders[ "Accept-Language" ] = I8N.locale();
	}
	return {
		...headers,
		...defaultHeaders
	};
}

function FetchOptsProcessor( httpMethod: string, url: string, init: RequestInit ): RequestInit {
	if ( SSOApi.isSSOEndpoint( url ) ) {
		init = {
			...init,
			credentials: "include"
		};
	}
	return init;
}

export const ssoState = {
	state: "hola",
};

function SsoStateProcessor( httpMethod: string, url: string, json: any ) {
	if ( isSSOEndpoint( url ) ) {
		if ( json.state ) {
			ssoState.state = json.state;
		}
	}
}

function SsoStateOptionsProcessor( httpMethod: string, url: string, init: RequestInit ) {
	if ( isSSOEndpoint( url ) ) {
		if ( ssoState.state ) {
			if ( init.body && typeof init.body === "string" ) {
				try {
					const o = JSON.parse( init.body );
					if ( o.state == null ) {
						o.state = ssoState.state;
						init.body = JSON.stringify( o );
					}
				} catch ( e ) {

				}
			} else if ( init.body == null && ( init.method === "PUT" || init.method === "POST" ) ) {
				init.body = JSON.stringify( { state: ssoState.state } );
			}
		}
	}
	return init;
}

export function configureApi() {

	if ( window.apiConfig ) {
		if ( window.apiConfig.projectionAPI ) {
			RestApiConfig.default.projectionApi().updateFromData( window.apiConfig.projectionAPI );
		}
		if ( window.apiConfig.propertyImagesApi ) {
			RestApiConfig.default.propertyImagesApi().updateFromData( window.apiConfig.propertyImagesApi );
		}
		if ( window.apiConfig.gisJobServiceApi ) {
			RestApiConfig.default.gisJobServiceApi().updateFromData( window.apiConfig.gisJobServiceApi );
		}
		if ( window.apiConfig.gateway ) {
			RestApiConfig.default.authAPI().updateFromData( window.apiConfig.gateway + "/dldrest" );
			RestApiConfig.default.areaTxAPI().updateFromData( window.apiConfig.gateway + "/areawise" );
			RestApiConfig.default.tabuTxnApi().updateFromData( window.apiConfig.gateway );
			RestApiConfig.default.propertyRegistryAPI().updateFromData( window.apiConfig.gateway + "/properties" );
			RestApiConfig.default.propertySvcApi().updateFromData( window.apiConfig.gateway + "/property" );
			BcsConfig.api().updateFromData( window.apiConfig.gateway + "/bcs/integration" );
		}
		if ( window.apiConfig.vaultAPI ) {
			VaultConfig.default.vaultApi().updateFromData( window.apiConfig.vaultAPI );
		}
		if ( window.apiConfig.profile ) {
			RestApiConfig.default.profileAPI().updateFromData( window.apiConfig.profile );
		}
		if ( window.apiConfig.tabuMobile ) {
			TabuMobileConfig.tabuAPI().updateFromData( window.apiConfig.tabuMobile );
		}
		if ( window.apiConfig.tabuSmartAPI ) {
			TabuMobileConfig.tabuSmartAPI().updateFromData( window.apiConfig.tabuSmartAPI );
		}
		if ( window.apiConfig.profilepic ) {
			RestApiConfig.default.profilePicAPI().updateFromData( window.apiConfig.profilepic );
		}
		if ( window.apiConfig.sso ) {
			SSOConfig.default.ssoAPI().updateFromData( window.apiConfig.sso );
		}
		if ( window.apiConfig.verticalAppAPI ) {
			SSOConfig.default.verticalAppAPI().updateFromData( window.apiConfig.verticalAppAPI );
		}
		if ( window.apiConfig.ndaAPI ) {
			SSOConfig.default.ndaAPI().updateFromData( window.apiConfig.ndaAPI );
		}
		if ( window.apiConfig.bcsRating ) {
			BcsConfig.api().updateFromData( window.apiConfig.bcsRating );
		}
		SSOConfig.default.ssoAPI().addCorrectiveTask( "451", ( data ) => {
			let profile = data?.data?.error ?? data.data;
			if ( profile ) {
				setSSOUser( profile );
				return true;
			}
			return false;
		} );
		if ( window.apiConfig.rtRegistrationAPI ) {
			RTRegistrationConfig.default.rtRegAPI().updateFromData( window.apiConfig.rtRegistrationAPI );
		}
		if ( window.apiConfig.greenListAPI ) {
			GreenListConfig.default.greenListAPI().updateFromData( window.apiConfig.greenListAPI );
		}
		if ( window.apiConfig.greenListLookupAPI ) {
			GreenListConfig.default.greenListLookupAPI().updateFromData( window.apiConfig.greenListLookupAPI );
		}
		if ( window.apiConfig.ejariAPI ) {
			EjariApiConfig.ejariAPI().updateFromData( window.apiConfig.ejariAPI );
			HandTakeOverAPIConfig.handTakeOverAPI().updateFromData( window.apiConfig.ejariAPI );
		}
		if ( window.apiConfig.ejariPayUrl ) {
			EjariApiConfig.ejariAPI().updateFromData( { shortUrl: window.apiConfig.ejariPayUrl } );
		}
		if ( window.apiConfig.ownerCommitteeAPI ) {
			OwnerCommitteeConfig.default.ownerCommitteeAPI().updateFromData( window.apiConfig.ownerCommitteeAPI );
		}
		if ( window.apiConfig.vipOwnerAPI ) {
			VIPOwnerConfig.default.vipOwnerAPI().updateFromData( window.apiConfig.vipOwnerAPI );
		}
		if ( window.apiConfig.RVSApi ) {
			RVSConfig.default.rvsAPI().updateFromData( window.apiConfig.RVSApi );
		}
		if ( window.apiConfig.mollakMCAPI ) {
			RVSConfig.default.mollakMCAPI().updateFromData( window.apiConfig.mollakMCAPI );
		}
		if ( window.apiConfig.mollakServiceChargeAPI ) {
			MollakServiceChargeConfig.default.mollakServiceChargeAPI().updateFromData( window.apiConfig.mollakServiceChargeAPI );
		}
		if ( window.apiConfig.taqyimeeAPI ) {
			ExpernalValuationConfig.default.taqyimeeAPI().updateFromData( window.apiConfig.taqyimeeAPI );
		}
		if ( window.apiConfig.trakheesiCertAPI ) {
			ExpernalValuationConfig.default.trakheesiCertAPI().updateFromData( window.apiConfig.trakheesiCertAPI );
		}
		if ( window.apiConfig.classificationRankAPI ) {
			ExpernalValuationConfig.default.classificationRankAPI().updateFromData( window.apiConfig.classificationRankAPI );
		}
		if ( window.apiConfig.mortgageQuotationAPI ) {
			MortgageQuotationConfig.default.mortgageQuotationAPI().updateFromData( window.apiConfig.mortgageQuotationAPI );
		}
		if ( window.apiConfig.rdcCasesAPI ) {
			RDCCasesConfig.default.rdcCasesAPI().updateFromData( window.apiConfig.rdcCasesAPI );
		}
		if ( window.apiConfig.enocMAPI ) {
			enocMConfig.default.enocMAPI().updateFromData( window.apiConfig.enocMAPI );
		}
		if ( window.apiConfig.enocDocAPI ) {
			enocMConfig.default.enocDocAPI().updateFromData( window.apiConfig.enocDocAPI );
		}
		if ( window.apiConfig.tabuPersonAPI ) {
			enocMConfig.default.tabuPersonAPI().updateFromData( window.apiConfig.tabuPersonAPI );
		}
		if ( window.apiConfig.addPropertyAPI ) {
			AddPropertyConfig.addPropertyAPI().updateFromData( window.apiConfig.addPropertyAPI );
		}
		if ( window.apiConfig.privateSellAPI ) {
			privateSellConfig.default.privateSellApi().updateFromData( window.apiConfig.privateSellAPI );
		}
		if ( window.apiConfig.identityOTPAPI ) {
			privateSellConfig.default.identityOTPApi().updateFromData( window.apiConfig.identityOTPAPI );
		}
		if ( window.apiConfig.askMalikAPI ) {
			AskMalikConfig.default.askMalikAPI().updateFromData( window.apiConfig.askMalikAPI );
		}
		if ( window.apiConfig.dldCmsAPI ) {
			AskMalikConfig.default.dldCmsAPI().updateFromData( window.apiConfig.dldCmsAPI );
		}
		if ( window.apiConfig.rentalIndexEjariContract ) {
			EjariApiConfig.ejariRxApi().updateFromData( window.apiConfig.rentalIndexEjariContract );
		}
		if ( window.apiConfig.ejariPropertyWalletAPI ) {
			EjariApiConfig.ejariPropertyWalletAPI().updateFromData( window.apiConfig.ejariPropertyWalletAPI );
		}
		if ( window.apiConfig.jopAPI ) {
			jopConfig.jopAPI().updateFromData( window.apiConfig.jopAPI );
		}
		if ( window.apiConfig.jopGateAPI ) {
			jopConfig.jopGateAPI().updateFromData( window.apiConfig.jopGateAPI );
		}
		if ( window.apiConfig.mollakMeydaanAPI ) {
			MollakMeydaanConfig.mollakMeydaanAPI().updateFromData( window.apiConfig.mollakMeydaanAPI );
		}
		if ( window.apiConfig.blockApi ) {
			AddPropertyConfig.blockApi().updateFromData( window.apiConfig.blockApi );
		}
	}

	rest.addHeaderProcessor( DefaultHeaderProcessor );
	rest.addResponseProcessor( handleHttpResponse );
	rest.addHeaderProcessor( TokenHeaderProcessor );
	rest.addFetchOptionProcessor( FetchOptsProcessor );
	// rest.addJsonProcessor(SsoStateProcessor);
	// rest.addFetchOptionProcessor(SsoStateOptionsProcessor)
}
